import * as Common from '@/tenant/common';

export class SalesCashBalanceQuery extends Common.ReportQuery {
    constructor(){
        super("SalesCashBalanceQuery", null);
    }
    // public closingDate: Date = null;
    public startDate: Date = null;
    public endDate: Date = null;    
    public segment: Common.Segment = null;
    public currencyCode: string = null;
    public includeClosingWaiting: boolean = false;
    public onExcelExport:boolean = false;           
}

export class SalesCashBalanceTemplateQuery extends Common.ReportTemplateQuery {
  queryName ='SalesCashBalanceQuery';
  sort = 'id';
  constructor() {
    super();
  }
}
